import type { ReactNode } from "react"

import { Heading, Text } from "@/components/ui"

interface TabEmptyStateProps {
  title: ReactNode
  body: ReactNode
  action: ReactNode
}

export const TabEmptyState = ({ title, body, action }: TabEmptyStateProps) => (
  <div className="@container pt-600 pb-800 @2xl:pt-750" data-testid="tab-empty-state">
    <div className="max-w-measure mx-auto flex flex-col items-center text-center">
      <Heading as="h2" variant="md" tone="strong" balance className="@2xl:text-heading-xl leading-5.75 font-semibold tracking-tight @2xl:leading-8">
        {title}
      </Heading>
      <Text variant="body" family="text" tone="strong" balance className="@2xl:text-body-lg mt-250">
        {body}
      </Text>
      <div className="mt-500 @2xl:mt-750">{action}</div>
    </div>
  </div>
)
